import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { toast } from 'react-toastify';
import { authorizeStripe } from '../../api/stripeApi';

export const StripeConnectCallback: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const hasProcessedRef = useRef(false);

  useEffect(() => {
    if (hasProcessedRef.current) {
      return;
    }

    hasProcessedRef.current = true;

    const processCallback = async () => {
      try {
        const code = searchParams.get('code');
        const error = searchParams.get('error');

        if (error) {
          toast.error('Stripe authorization was cancelled.');
          navigate('/settings/branding');
          return;
        }

        if (!code) {
          toast.error('No Stripe authorization code was received.');
          navigate('/settings/branding');
          return;
        }

        await authorizeStripe(code);

        toast.success('Stripe connected successfully.');

        navigate('/settings/branding', {
          replace: true,
        });
      } catch (error) {
        console.error('Stripe Connect callback error:', error);

        toast.error('Failed to connect Stripe.');

        navigate('/settings/branding', {
          replace: true,
        });
      }
    };

    processCallback();
  }, [navigate, searchParams]);

  return (
    <div className="flex min-h-[400px] items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-strivre-burgundy" />
        <div className="text-center">
          <h2 className="text-lg font-semibold text-slate-900">
            Connecting Stripe
          </h2>
          <p className="text-sm text-slate-500">
            Please wait while we complete the Stripe authorization.
          </p>
        </div>
      </div>
    </div>
  );
};

export default StripeConnectCallback;